import { render, staticRenderFns } from "./WorkflowStepTitle.vue?vue&type=template&id=94a31f92"
import script from "./WorkflowStepTitle.vue?vue&type=script&setup=true&lang=ts"
export * from "./WorkflowStepTitle.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports